import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useCallback } from "react";
import { apiClientPrice, apiGroupEnterprise } from "../../services/data";
import LoadingEffect from "../../components/LoadingEffect";
import {
  Container,
  ContainerLoading,
  Section,
} from "../../styles-components/Container";
import {
  ErrorMessage,
  FormHeader,
  Label,
} from "../../styles-components/FormItens";
import { Button, ButtonA } from "../../styles-components/Buttons";
import { SubTitle } from "../../styles-components/Texts";
import { Filter, FilterGroup, FilterSelect, TablePrices } from "./styles";
import { parseISO } from "date-fns/esm";
import { format } from "date-fns";
import { BsFillTrashFill } from "react-icons/bs";
import UseRedirectView from "../../utils/UseRedirectView";
import TablePaginationMore from "../../components/TablePaginationMore";
import { toast } from "react-toastify";

const ListServicesValue = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSearching, setIsSearching] = useState(false);
  const [isSecondSearching, setIsSecondSearching] = useState(false);
  const [fivePrices, setFivePrices] = useState([]);
  const [clients, setClients] = useState([]);
  const [filtredPrices, setFiltredPrices] = useState([]);
  const [filterValue, setFilterValue] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (filterValue !== "") {
      handleFilter(filterValue);
    }
  }, [filterValue, handleFilter]);

  const fetchData = useCallback(async () => {
    await apiClientPrice.index().then((response) => {
      setFivePrices(response.data.data);
    });
    await apiGroupEnterprise.index().then((response) => {
      setClients(response.data.data);
    });
    setIsLoading(false);
  }, [apiClientPrice, setFivePrices, setClients]);

  const handleFilter = useCallback(
    (id) => {
      const fetchPrices = async (id) => {
        setIsSearching(true);
        await apiClientPrice.show(id).then((response) => {
          let aux = {
            header: "",
            data: [],
          };
          var data = [];
          response.data.data.map((table, index) => {
            aux = {
              header: table[0].product_service.nome,
              data: [...table],
            };
            data = [...data, aux];
          });
          setFiltredPrices(data);
          setIsSecondSearching(true);
        });
        setIsSearching(false);
      };

      fetchPrices(id);
    },
    [apiClientPrice, setFiltredPrices, setIsSearching]
  );

  const handleDelete = useCallback(
    async (service_id, group_enterprises_id, date_start) => {
      try {
        await apiClientPrice
          .destroy(service_id, group_enterprises_id, date_start)
          .then((response) => {
            if (response.data.data && response.data.data.error) {
              toast.error(response.data.data.message);
            } else {
              toast.success("Preço de serviço deletado com sucesso!");
              fetchData();
              handleFilter(filterValue);
            }
          });
      } catch (error) {
        toast.error("Algo deu errado ao deletar!");
      }
    },
    [filterValue, apiClientPrice, fetchData, handleFilter]
  );

  const columns = [
    {
      Header: "NCM",
      accessor: "product_service.ncm",
    },
    {
      Header: "VALOR",
      accessor: "value",
      Cell: ({ cell }) =>
        cell.row.original.value.toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }),
    },
    {
      Header: "INÍCIO",
      accessor: "date_start",
      Cell: ({ cell }) =>
        format(parseISO(cell.row.original.date_start), "dd/MM/yyyy"),
    },
    {
      Header: "FIM",
      accessor: "date_end",
      Cell: ({ cell }) =>
        cell.row.original.date_end
          ? format(parseISO(cell.row.original.date_end), "dd/MM/yyyy")
          : "",
    },
    {
      Header: "AÇÕES",
      Cell: ({ cell }) =>
        cell.row.original.canBeDeleted ? (
          <ButtonA
            as={"button"}
            style={{ margin: "5px" }}
            color="--white"
            backgroundColor="--red"
            onClick={() =>
              handleDelete(
                cell.row.original.service_id,
                cell.row.original.group_enterprises_id,
                cell.row.original.date_start
              )
            }
          >
            <BsFillTrashFill />
          </ButtonA>
        ) : (
          ""
        ),
    },
  ];

  return (
    <>
      {isLoading ? (
        <LoadingEffect />
      ) : (
        <Container>
          <FormHeader>
            <h1>Preços</h1>
            <Button
              color="--white"
              backgroundColor="--orange"
              onClick={() => UseRedirectView.to("servicos/valores/create")}
            >
              Cadastrar
            </Button>
          </FormHeader>
          <Section>
            <SubTitle>Ultimos 5 preços inseridos</SubTitle>
            {fivePrices.length > 0 ? (
              <TablePrices>
                <thead>
                  <tr>
                    <th>SERVIÇO</th>
                    <th>NCM</th>
                    <th>VALOR</th>
                    <th>INÍCIO</th>
                    <th>FIM</th>
                    <th>AÇÕES</th>
                  </tr>
                </thead>
                <tbody>
                  {fivePrices.map((price) => (
                    <tr key={price.created_at}>
                      <td>{price.product_service.nome}</td>
                      <td>{price.product_service.ncm}</td>
                      <td>
                        {price.value.toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                          minimumFractionDigits: 2,
                        })}
                      </td>
                      <td>
                        {format(parseISO(price.date_start), "dd/MM/yyyy")}
                      </td>
                      <td>
                        {price.date_end !== null
                          ? format(parseISO(price.date_end), "dd/MM/yyyy")
                          : ""}
                      </td>
                      <td>
                        {price.canBeDeleted && (
                          <ButtonA
                            as={"button"}
                            style={{ margin: "5px" }}
                            color="--white"
                            backgroundColor="--red"
                            onClick={() =>
                              handleDelete(
                                price.service_id,
                                price.group_enterprises_id,
                                price.date_start
                              )
                            }
                          >
                            <BsFillTrashFill />
                          </ButtonA>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </TablePrices>
            ) : (
              <ErrorMessage color={"--yellow"}>
                Ainda não há nenhum preço cadastrado
              </ErrorMessage>
            )}
            <FilterGroup>
              <SubTitle>Filtrar preços por cliente</SubTitle>
              <Filter>
                <Label>Cliente:</Label>
                <FilterSelect
                  onChange={(e) => setFilterValue(e.target.value)}
                  value={filterValue}
                >
                  <option></option>
                  {clients.map((cliente) => (
                    <option key={cliente.id} value={cliente.id}>
                      {cliente.name}
                    </option>
                  ))}
                </FilterSelect>
              </Filter>
              {isSearching ? (
                <ContainerLoading>
                  <LoadingEffect />
                </ContainerLoading>
              ) : (
                <>
                  {filtredPrices.length > 0 ? (
                    <>
                      {filtredPrices.map((table, index) => (
                        <TablePaginationMore
                          key={index}
                          header={table.header}
                          columnsData={columns}
                          contentData={table.data}
                          type={"m"}
                          pageSizeValue={10}
                        />
                      ))}
                    </>
                  ) : (
                    <>
                      {isSecondSearching && (
                        <ErrorMessage color={"--yellow"}>
                          Este cliente não possui nenhum preço cadastrado
                        </ErrorMessage>
                      )}
                    </>
                  )}
                </>
              )}
            </FilterGroup>
          </Section>
        </Container>
      )}
    </>
  );
};

export default ListServicesValue;
